/* bb-chat — BasicsLife product-recommendation chat widget (vanilla, self-contained)
 * Floating bubble → panel → POST /apps/chat (bb-chat Worker) → product cards.
 * Injected on the theme; calls the same-origin Worker (no keys in the browser). */
(function () {
  if (window.__bbChatBooted) return;
  window.__bbChatBooted = true;

  var ENDPOINT = "/apps/chat";
  var FAVICON = ((document.querySelector('link[rel~="icon"]')||{}).href) || "https://cdn.shopify.com/s/files/1/0245/1138/1585/files/Untitled-4-02_1_-_Copy.png";
  var INK = "#1a1a1a";
  var ACC = "#FECB09";   // BasicsLife theme yellow
  var ACC2 = "#C99A00";
  var ONACC = "#141414"; // black text/icon on yellow
  var SUGGESTIONS = [
    { label: "🔥 Best selling shirts", q: "best selling shirts" },
    { label: "💸 Low price shirts", q: "low price shirts" },
    { label: "🖤 Black shirt combination", q: "black shirt combination" },
    { label: "🆕 New arrivals", q: "new arrivals" },
    { label: "👔 Office wear", q: "office wear" },
    { label: "🧥 Weekend outfits", q: "weekend outfit" },
    { label: "📏 Size help", q: "what size should i buy" },
    { label: "🏷️ Offers", q: "on sale" },
  ];

  // ---------- styles ----------
  var css = `
  #bbc-bubble{position:fixed;right:18px;bottom:18px;width:58px;height:58px;border-radius:50%;background:${ACC};color:${ONACC};border:0;cursor:pointer;box-shadow:0 6px 22px rgba(0,0,0,.28);z-index:2147483000;display:flex;align-items:center;justify-content:center;font-size:26px;transition:transform .15s}
  #bbc-bubble:hover{transform:scale(1.06)}
  #bbc-bubble.bbc-hide{display:none}
  #bbc-panel{position:fixed;top:0;right:0;width:400px;max-width:100vw;height:100vh;height:100dvh;background:#fff;box-shadow:-14px 0 40px -10px rgba(0,0,0,.35);z-index:2147483647;display:none;flex-direction:column;overflow:hidden;font-family:-apple-system,Roboto,Segoe UI,sans-serif}
  #bbc-panel.bbc-open{display:flex}
  .bbc-head{background:#fff;color:#141414;padding:14px 16px;display:flex;align-items:center;gap:10px;border-bottom:1px solid #eceae6;flex:none}
  .bbc-head b{font-size:16px;font-weight:700;flex:1}
  .bbc-head small{display:none}
  .bbc-av{width:32px;height:32px;border-radius:50%;background:radial-gradient(120% 120% at 30% 20%,#ffe680,${ACC} 58%,${ACC2});display:flex;align-items:center;justify-content:center;flex:none}
  .bbc-av img{width:18px;height:18px;filter:brightness(0);display:block}
  .bbc-tools{display:flex;gap:2px;margin-left:auto}
  .bbc-tool{width:34px;height:34px;border-radius:50%;border:0;background:transparent;color:#8a8a8a;cursor:pointer;display:flex;align-items:center;justify-content:center;font-size:18px;line-height:1}
  .bbc-tool:hover{background:#f3f1ec;color:#444}
  .bbc-x{font-size:22px;color:#999}
  .bbc-body{flex:1;overflow-y:auto;padding:16px;background:#fff;-webkit-overflow-scrolling:touch;overscroll-behavior:contain}
  .bbc-recos{display:flex;flex-direction:column;align-items:flex-start;gap:7px;margin:0 0 12px}
  .bbc-recos button{background:#fff;border:1px solid #d9d9d9;border-radius:16px;padding:9px 13px;font-size:12.5px;cursor:pointer;color:#1a1a1a;text-align:left;line-height:1.3;max-width:90%}
  .bbc-recos button:hover{border-color:#1a1a1a;background:#fafafa}
  .bbc-login{background:#fff;border:1px solid #ececec;border-radius:12px;padding:12px;margin:0 0 12px;display:flex;align-items:center;gap:11px}
  .bbc-login-ico{font-size:20px;line-height:1}
  .bbc-login-body{flex:1;min-width:0}
  .bbc-login-body b{font-size:13px;display:block;color:#1a1a1a}
  .bbc-login-body span{font-size:11px;color:#888;display:block;margin-top:2px}
  .bbc-login-btn{background:${ACC};color:${ONACC};text-decoration:none;font-size:11px;font-weight:700;letter-spacing:.4px;padding:9px 15px;border-radius:8px;white-space:nowrap}
  .bbc-login-btn:hover{background:#000}
  .bbc-msg{max-width:84%;padding:9px 13px;border-radius:14px;margin:0 0 10px;font-size:13.5px;line-height:1.45;word-wrap:break-word}
  .bbc-fb{display:flex;align-items:center;gap:6px;margin:4px 2px 12px;padding:2px 2px 2px 8px}
  .bbc-fb-q{font-size:12px;font-weight:500;color:#6b6b6b;flex:1;min-width:0;line-height:1.2}
  .bbc-fb-btns{display:flex;gap:2px;flex:none}
  .bbc-fbb{border:0;background:transparent;cursor:pointer;font-size:16px;line-height:1;padding:4px 6px;border-radius:8px;opacity:.6;transition:opacity .12s,background .12s,transform .1s}
  .bbc-fbb:hover{opacity:1;background:#efece5;transform:scale(1.1)}
  .bbc-fbb.bbc-fb-on[data-r=up]{opacity:1;background:#e7f5ec}
  .bbc-fbb.bbc-fb-on[data-r=down]{opacity:1;background:#fdeaea}
  .bbc-fbb.bbc-fb-dim{opacity:.25}
  .bbc-msg.bot{background:#f3f1ec;color:#1c1c1c;border:0;border-bottom-left-radius:4px}
  .bbc-msg.user{background:#141414;color:#fff;margin-left:auto;border-bottom-right-radius:4px}
  .bbc-typing{display:flex;gap:4px;padding:11px 14px;background:#fff;border:1px solid #ececec;border-radius:14px;width:fit-content}
  .bbc-typing span{width:7px;height:7px;border-radius:50%;background:#bbb;animation:bbcb 1s infinite}
  .bbc-typing span:nth-child(2){animation-delay:.15s}.bbc-typing span:nth-child(3){animation-delay:.3s}
  @keyframes bbcb{0%,60%,100%{transform:translateY(0);opacity:.5}30%{transform:translateY(-5px);opacity:1}}
  .bbc-rail{display:flex;gap:10px;overflow-x:auto;padding:2px 2px 10px;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch}
  .bbc-rail::-webkit-scrollbar{height:0}
  .bbc-card{flex:0 0 150px;scroll-snap-align:start;background:#fff;border:1px solid #ececec;border-radius:12px;overflow:hidden;display:flex;flex-direction:column}
  .bbc-imgw{position:relative;background:#f0f0f0;display:block}
  .bbc-imgw img{width:100%;height:auto;object-fit:contain;display:block}
  .bbc-badge{position:absolute;top:6px;left:6px;background:rgba(0,0,0,.72);color:#fff;font-size:9px;font-weight:700;letter-spacing:.4px;text-transform:uppercase;padding:2px 6px;border-radius:5px}
  .bbc-off{position:absolute;top:6px;right:6px;background:#e11900;color:#fff;font-size:9.5px;font-weight:800;padding:2px 6px;border-radius:5px}
  .bbc-cb{padding:8px 9px 10px;display:flex;flex-direction:column;gap:5px}
  .bbc-ct{font-size:12px;line-height:1.3;color:#1a1a1a;height:31px;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}
  .bbc-pr{font-size:13px;font-weight:800;color:#1a1a1a}.bbc-pr s{font-weight:400;color:#999;font-size:11px;margin-left:5px}
  .bbc-stk{font-size:10px;font-weight:700}
  .bbc-stk.ok{color:#188a42}.bbc-stk.low{color:#d27a00}.bbc-stk.no{color:#999}
  .bbc-sw{display:flex;gap:4px;flex-wrap:wrap}.bbc-sw i{width:13px;height:13px;border-radius:50%;border:1px solid #ddd;display:inline-block}
  .bbc-atc{margin-top:2px;background:${ACC};color:${ONACC};border:0;border-radius:8px;padding:8px;font-size:11px;font-weight:700;letter-spacing:.5px;cursor:pointer}
  .bbc-atc:disabled{background:#bbb;cursor:default}
  .bbc-sizes{display:flex;flex-wrap:wrap;gap:4px;align-items:center;margin-top:2px}
  .bbc-sizelbl{font-size:10px;color:#888;width:100%}
  .bbc-size{min-width:30px;background:#fff;border:1px solid #cfcfcf;border-radius:6px;padding:5px 7px;font-size:11px;font-weight:700;color:#1a1a1a;cursor:pointer}
  .bbc-size:hover{border-color:#1a1a1a}
  .bbc-size.oos{color:#bbb;text-decoration:line-through;cursor:not-allowed;border-color:#eee}
  .bbc-added{display:flex;gap:6px;margin-top:4px}
  .bbc-added a{flex:1;text-align:center;text-decoration:none;font-size:10.5px;font-weight:700;letter-spacing:.4px;padding:7px 4px;border-radius:7px}
  .bbc-vc{background:#f0f0f1;color:#1a1a1a}.bbc-co{background:${ACC};color:${ONACC}}
  .bbc-cmp{display:flex;gap:10px}.bbc-cmp .bbc-card{flex:1}
  .bbc-foot{flex:none;border-top:1px solid #eee;background:#fff;padding:10px}
  .bbc-disc{font-size:10px;color:#9a9a9a;text-align:center;padding:9px 2px 1px;line-height:1.4}
  .bbc-disc a{color:#9a9a9a;text-decoration:underline}
  .bbc-sugg{display:flex;gap:6px;overflow-x:auto;padding-bottom:8px}.bbc-sugg::-webkit-scrollbar{height:0}
  .bbc-sugg button{flex:none;background:#fffae0;border:1px solid #f2df8f;border-radius:16px;padding:8px 12px;font-size:12px;cursor:pointer;white-space:nowrap;color:#141414;font-weight:600}
  .bbc-inp{display:flex;gap:8px;align-items:center}
  .bbc-inp input{flex:1;border:1px solid #e2e2e2;border-radius:22px;padding:11px 15px;font-size:14px;outline:none}
  .bbc-inp input:focus{border-color:${INK}}
  .bbc-send{width:42px;height:42px;border-radius:50%;background:${ACC};color:${ONACC};border:0;cursor:pointer;font-size:17px;flex:none}
  .bbc-toast{position:fixed;left:50%;bottom:90px;transform:translateX(-50%);background:${ACC};color:${ONACC};padding:10px 18px;border-radius:22px;font-size:13px;z-index:2147483002;opacity:0;transition:opacity .2s;pointer-events:none}
  .bbc-toast.show{opacity:1}
  .bbc-ord{background:#fff;border:1px solid #ececec;border-radius:12px;padding:11px 12px;margin:0 0 10px}
  .bbc-ord-h{display:flex;align-items:center;justify-content:space-between;gap:8px}
  .bbc-ord-h b{font-size:13px}
  .bbc-ost{font-size:9.5px;font-weight:800;letter-spacing:.4px;text-transform:uppercase;padding:3px 8px;border-radius:20px}
  .bbc-ost.green{background:#e7f5ec;color:#188a42}.bbc-ost.amber{background:#fdf0df;color:#b9740a}.bbc-ost.grey{background:#eee;color:#777}
  .bbc-ord-sub{font-size:11px;color:#888;margin:3px 0 8px}
  .bbc-oi{display:flex;align-items:center;gap:8px;margin:5px 0}
  .bbc-oi img{width:34px;height:34px;border-radius:6px;object-fit:cover;background:#f0f0f0;flex:none}
  .bbc-oi span{font-size:11.5px;color:#333;line-height:1.3}
  .bbc-otrk{display:inline-block;background:${ACC};color:${ONACC};text-decoration:none;font-size:11px;font-weight:700;letter-spacing:.4px;padding:8px 12px;border-radius:8px}
  .bbc-ord-actions{display:flex;gap:8px;margin-top:9px;flex-wrap:wrap}
  .bbc-more{display:block;text-align:center;background:#fff;border:1px solid #e3ded4;border-radius:12px;padding:12px;margin:2px 0 10px;text-decoration:none;color:#141414;font-weight:700;font-size:12.5px}
  .bbc-more:hover{border-color:${ACC}}
  .bbc-msg.bot a{color:#8a6d00;font-weight:700}
  .bbc-fb{display:flex;align-items:center;gap:8px;background:#fff;border:1px solid #ececec;border-radius:12px;padding:10px 12px;margin:2px 0 10px}
  .bbc-fbq{font-size:12.5px;color:#555;flex:1;line-height:1.3}
  .bbc-fbbtn{background:#f4f4f5;border:1px solid #e2e2e2;border-radius:10px;font-size:18px;line-height:1;padding:6px 10px;cursor:pointer}
  .bbc-fbbtn:hover{border-color:${INK};background:#fff}
  .bbc-fbthanks{font-size:12.5px;color:#188a42;font-weight:600}
  @media(max-width:480px){#bbc-panel{width:100vw}}
  html.bbc-active .wa-chat-box,html.bbc-active [class*="wa-chat-box"],html.bbc-active [class*="wa-messenger"],html.bbc-active [id*="whatsapp"],html.bbc-active [class*="whatsapp"],html.bbc-active [id*="wati"],html.bbc-active [class*="wati"],html.bbc-active iframe[src*="wati"],html.bbc-active iframe[src*="customerreviews.google"],html.bbc-active [class*="grsf"],html.bbc-active [id*="gcr"],html.bbc-active [class*="shop-pay"]{visibility:hidden!important;opacity:0!important;pointer-events:none!important}
  `;
  var st = document.createElement("style"); st.textContent = css; document.head.appendChild(st);

  // ---------- DOM ----------
  var bubble = document.createElement("button");
  bubble.id = "bbc-bubble"; bubble.innerHTML = "💬"; bubble.setAttribute("aria-label", "Chat with us");
  document.body.appendChild(bubble);

  var panel = document.createElement("div");
  panel.id = "bbc-panel"; panel.setAttribute("role", "dialog"); panel.setAttribute("aria-label", "BasicsLife shopping assistant");
  panel.innerHTML =
    '<div class="bbc-head"><div class="bbc-av"><img src="' + FAVICON + '" alt=""></div><b>BasicsLife Assistant</b><div class="bbc-tools"><button class="bbc-tool" id="bbc-reset" aria-label="Restart chat" title="Restart">↻</button><button class="bbc-x bbc-tool" aria-label="Close chat">×</button></div></div>' +
    '<div class="bbc-body" id="bbc-body" role="log" aria-live="polite"></div>' +
    '<div class="bbc-foot"><div class="bbc-sugg" id="bbc-sugg"></div><div class="bbc-inp"><input id="bbc-text" type="text" placeholder="Try “black shirts under 1000”" autocomplete="off" aria-label="Ask about any product"><button class="bbc-send" id="bbc-send" aria-label="Send message">➤</button></div><div class="bbc-disc">Chat is powered by AI. We may store chat history to improve results. Avoid sharing personal or sensitive information. See <a href="/pages/privacy-policy" target="_blank" rel="noopener">Privacy Policy</a>.</div></div>';
  document.body.appendChild(panel);

  var body = panel.querySelector("#bbc-body");
  var input = panel.querySelector("#bbc-text");
  var suggWrap = panel.querySelector("#bbc-sugg");
  var booted = false;

  function esc(s) { var d = document.createElement("div"); d.textContent = s == null ? "" : String(s); return d.innerHTML; }
  function inr(n) { return n == null ? "" : "₹" + Number(n).toLocaleString("en-IN"); }
  var COLORHEX = { black: "#111", white: "#fff", navy: "#1b2a4e", blue: "#2c6fbb", red: "#c0392b", maroon: "#7b1e2b", green: "#2e7d32", olive: "#6b6f3a", grey: "#9a9a9a", gray: "#9a9a9a", brown: "#6e4b2a", beige: "#d8c7a8", pink: "#e48aa8", purple: "#6f3f9e", yellow: "#e7c63a", orange: "#e0762a", teal: "#1f8a8a", sage: "#9cae8a", charcoal: "#444" };
  function swatchHex(name) { var k = String(name).toLowerCase(); for (var c in COLORHEX) if (k.indexOf(c) > -1) return COLORHEX[c]; return "#ccc"; }

  var _savedY = 0, _locked = false;
  function isMobile() { return window.matchMedia("(max-width:768px)").matches; }
  function lockScroll() {
    if (_locked || !isMobile()) return;
    _locked = true;
    _savedY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var b = document.body;
    b.style.position = "fixed"; b.style.top = (-_savedY) + "px"; b.style.left = "0"; b.style.right = "0"; b.style.width = "100%"; b.style.overflow = "hidden";
  }
  function unlockScroll() {
    if (!_locked) return;
    _locked = false;
    var b = document.body;
    b.style.position = ""; b.style.top = ""; b.style.left = ""; b.style.right = ""; b.style.width = ""; b.style.overflow = "";
    window.scrollTo(0, _savedY);
  }
  var GREET_RECOS = ["Show me your best sellers", "New arrivals", "What goes with black trousers", "Casual shirts under 2000", "Slim fit vs regular fit?", "What should I wear to a wedding?", "Show me jackets", "Cotton shirts"];
  function pickGreetRecos() {
    var c = window.__BB_CUSTOMER;
    var nm = c && (c.first_name || c.name);
    var base = (nm && (c.orders_count > 0)) ? ["Picks for me"] : []; // logged-in returning customer → a personalized chip first
    var p = GREET_RECOS.slice(), o = base.slice();
    while (o.length < 3 && p.length) o.push(p.splice(Math.floor(Math.random() * p.length), 1)[0]);
    return o;
  }
  function bootGreeting() {
    var c = window.__BB_CUSTOMER;
    var nm = c && (c.first_name || c.name) ? String(c.first_name || c.name).trim().split(/\s+/)[0] : "";
    if (nm) return "Hi " + nm + "! 👋 Welcome back. Ask me for picks based on your wardrobe, a colour + type, a budget, or to track an order — or tap one below.";
    return "Hi! 👋 I'm your BasicsLife assistant. Ask me anything — or tap one of these to get started.";
  }
  var _bbcFloat = [];
  function bbcFloaters(hide) {
    try {
      if (hide) {
        _bbcFloat = [];
        document.querySelectorAll("div,iframe,aside,section,a[href]").forEach(function (n) {
          if (n.id === "bbc-panel" || n.id === "bbc-bubble" || n.id === "bbc-toast") return;
          if (n.closest && (n.closest("#bba-wrap") || n.closest("#bba-launch"))) return;
          if (typeof n.className === "string" && /bba-|bbc-/.test(n.className)) return;
          var cs = getComputedStyle(n);
          if (cs.position !== "fixed" || cs.display === "none" || cs.visibility === "hidden") return;
          var r = n.getBoundingClientRect();
          if (r.width < 8 || r.height < 8 || r.width > 260 || r.height > 260) return;
          var z = parseInt(cs.zIndex) || 0;
          var edge = r.right > window.innerWidth - 175 || r.bottom > window.innerHeight - 230 || r.left < 175;
          if (edge || z >= 40) { _bbcFloat.push([n, n.style.visibility, n.style.pointerEvents]); n.style.visibility = "hidden"; n.style.pointerEvents = "none"; }
        });
      } else {
        _bbcFloat.forEach(function (x) { x[0].style.visibility = x[1] || ""; x[0].style.pointerEvents = x[2] || ""; });
        _bbcFloat = [];
      }
    } catch (e) {}
  }
  // click-outside / Escape to close (parity with the PDP drawer)
  function onDocClick(e){
    if(!panel.classList.contains("bbc-open")) return;
    var t=e.target;
    if(panel.contains(t)) return;
    if(t.closest&&(t.closest("#bba-launch")||t.closest("#bbc-bubble")||t.closest("#bbc-toast"))) return;
    close();
  }
  function onEsc(e){ if(e.key==="Escape"&&panel.classList.contains("bbc-open")) close(); }
  function addOutside(){ setTimeout(function(){ document.addEventListener("click", onDocClick, true); }, 0); document.addEventListener("keydown", onEsc); }
  function removeOutside(){ document.removeEventListener("click", onDocClick, true); document.removeEventListener("keydown", onEsc); }
  function open() {
    bubble.classList.add("bbc-hide"); panel.classList.add("bbc-open"); document.documentElement.classList.add("bbc-active"); bbcFloaters(true); lockScroll(); addOutside();
    if (!booted) {
      booted = true; renderSugg();
      if (rlog && rlog.length) { replayRlog(); }
      else loadHistory(function (msgs) {
        if (msgs && msgs.length) { history = []; msgs.forEach(function (m) { m.role === "user" ? userSay(m.text) : botSay(m.text); history.push({ role: m.role, text: m.text }); }); history = history.slice(-16); saveHist(); }
        else { botSay(bootGreeting()); renderRecos(pickGreetRecos()); }
      });
      setTimeout(function () { input.focus(); }, 200);
    }
  }
  function close() {
    // on the FIRST close, if there was a real chat and no rating yet, ask once (panel stays open); next close exits
    panel.classList.remove("bbc-open"); bubble.classList.remove("bbc-hide"); document.documentElement.classList.remove("bbc-active"); bbcFloaters(false); unlockScroll(); removeOutside();
  }
  bubble.onclick = open;
  panel.querySelector(".bbc-x").onclick = close;
  function resetChat() { setReset(Date.now()); history = []; saveHist(); clearRlog(); body.innerHTML = ""; botSay(bootGreeting()); renderRecos(pickGreetRecos()); }
  var _rb = panel.querySelector("#bbc-reset"); if (_rb) _rb.onclick = resetChat;

  function renderSugg() { suggWrap.innerHTML = ""; SUGGESTIONS.forEach(function (s) { var b = document.createElement("button"); b.textContent = s.label; b.onclick = function () { send(s.q); }; suggWrap.appendChild(b); }); }
  function scroll() { body.scrollTop = body.scrollHeight; }
  /* 27 Oct (#47, his yes 15 Oct): phone numbers + email tappable too. Links are parked as @@BBLn@@ first so a number
     inside a link (wa.me/91...) is never linked twice. Phones only when written like a phone (+91 / 1800 / spaced
     landline / 5+5 mobile), so an unspaced 10-digit tracking number stays plain text. No lookbehind (old iPhone Safari). */
  function linkify(t) {
    var p = [], keep = function (h) { p.push(h); return "@@BBL" + (p.length - 1) + "@@"; };
    t = t.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, function (_, x, u) { return keep('<a href="' + u + '" target="_blank" rel="noopener">' + x + '</a>'); });
    t = t.replace(/(https?:\/\/[^\s<]+)/g, function (u) { return keep('<a href="' + u + '" target="_blank" rel="noopener">' + u.replace(/^https?:\/\//, "") + '</a>'); });
    t = t.replace(/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g, function (e) { return keep('<a href="mailto:' + e + '">' + e + '</a>'); });
    t = t.replace(/(^|[^\d+])(\+91[\s-]?[6-9]\d{4}[\s-]?\d{5}|\+91[\s-]?[6-9]\d{9}|1800[\s-]?\d{3,4}[\s-]?\d{3,4}|0\d{2,4}[\s-]\d{3,4}[\s-]\d{4}|[6-9]\d{4}[\s-]\d{5})(?!\d)/g, function (_, a, n) { return a + keep('<a href="tel:' + n.replace(/[^\d+]/g, "") + '">' + n + '</a>'); });
    return t.replace(/@@BBL(\d+)@@/g, function (_, i) { return p[+i]; });
  }
  function botSay(text) { var d = document.createElement("div"); d.className = "bbc-msg bot"; d.innerHTML = linkify(esc(text)); body.appendChild(d); scroll(); return d; }
  function userSay(text) { var d = document.createElement("div"); d.className = "bbc-msg user"; d.textContent = text; body.appendChild(d); scroll(); }
  function typing(on) { var ex = body.querySelector("#bbc-typ"); if (on) { if (ex) return; var d = document.createElement("div"); d.id = "bbc-typ"; d.className = "bbc-typing"; d.innerHTML = "<span></span><span></span><span></span>"; body.appendChild(d); scroll(); } else if (ex) ex.remove(); }
  function toast(msg) { var t = document.createElement("div"); t.className = "bbc-toast"; t.textContent = msg; document.body.appendChild(t); requestAnimationFrame(function () { t.classList.add("show"); }); setTimeout(function () { t.classList.remove("show"); setTimeout(function () { t.remove(); }, 250); }, 1800); }

  function stockBadge(q) {
    if (q == null) return '<span class="bbc-stk ok">In stock</span>';
    if (q <= 0) return '<span class="bbc-stk no">Sold out</span>';
    if (q <= 10) return '<span class="bbc-stk low">Low stock (' + q + ' left)</span>';
    return '<span class="bbc-stk ok">In stock</span>';
  }
  function card(p) {
    var el = document.createElement("div"); el.className = "bbc-card";
    el.innerHTML =
      '<a class="bbc-imgw" href="' + esc(p.url) + '"><img loading="lazy" src="' + esc(p.image_url) + '" alt="' + esc(p.title) + '"></a>' +
      '<div class="bbc-cb"><a href="' + esc(p.url) + '" class="bbc-ct" style="text-decoration:none">' + esc(p.title) + '</a>' +
      '<div class="bbc-pr">' + inr(p.price) + (p.compareAtPrice ? ' <s>' + inr(p.compareAtPrice) + '</s>' : '') + '</div></div>';
    return el;
  }
  function renderProducts(products, layout) {
    if (!products || !products.length) return;
    var wrap = document.createElement("div");
    wrap.className = layout === "comparison_table" ? "bbc-cmp" : "bbc-rail";
    products.forEach(function (p) { wrap.appendChild(card(p)); });
    body.appendChild(wrap); scroll();
  }
  function renderOrders(orders, meta) {
    if (!orders || !orders.length) return;
    orders.forEach(function (o) {
      var st = String(o.status || "").toUpperCase();
      var cls = (/FULFILLED|DELIVERED|COMPLETE/.test(st) && !/UN|PARTIAL/.test(st)) ? "green" : /UN|PENDING|PROCESS|OPEN/.test(st) ? "amber" : "grey";
      var items = (o.items || []).slice(0, 4).map(function (it) {
        return '<div class="bbc-oi">' + (it.image ? '<img src="' + esc(it.image) + '" alt="">' : "") + "<span>" + esc(it.title) + " ×" + (it.qty || 1) + "</span></div>";
      }).join("");
      var view = o.url ? '<a class="bbc-otrk" href="' + esc(o.url) + '" target="_blank" rel="noopener">View order</a>' : "";
      var trk = o.tracking && (o.tracking.url || o.tracking.number)
        ? '<a class="bbc-otrk" href="' + esc(o.tracking.url || "#") + '" target="_blank" rel="noopener">Track package</a>' : "";
      var el = document.createElement("div"); el.className = "bbc-ord";
      el.innerHTML =
        '<div class="bbc-ord-h"><b>Order ' + esc(o.name) + '</b><span class="bbc-ost ' + cls + '">' + esc(o.status) + "</span></div>" +
        '<div class="bbc-ord-sub">' + esc(o.date) + (o.total ? " · ₹" + Number(o.total).toLocaleString("en-IN") : "") + (o.payment ? " · " + esc(o.payment) : "") + "</div>" +
        items + '<div class="bbc-ord-actions">' + view + trk + "</div>";
      body.appendChild(el);
    });
    if (meta && meta.moreUrl) { var m = document.createElement("a"); m.className = "bbc-more"; m.href = meta.moreUrl; m.textContent = (meta.moreLabel || "View all orders") + " →"; body.appendChild(m); }
    scroll();
  }

  function defaultLoginUrl() { return "/account/login?return_url=" + encodeURIComponent(location.pathname + location.search); }
  function safeLoginUrl(u) {
    // same-origin relative paths only — reject absolute/protocol-relative (open-redirect safe)
    if (u && typeof u === "string" && u.charAt(0) === "/" && u.charAt(1) !== "/") {
      return u.indexOf("return_url=") > -1 ? u : u + (u.indexOf("?") > -1 ? "&" : "?") + "return_url=" + encodeURIComponent(location.pathname + location.search);
    }
    return defaultLoginUrl();
  }
  function renderLoginCard(url, text) {
    var el = document.createElement("div"); el.className = "bbc-login";
    var a = document.createElement("a"); a.className = "bbc-login-btn"; a.href = safeLoginUrl(url); a.textContent = "LOG IN";
    var bodyDiv = document.createElement("div"); bodyDiv.className = "bbc-login-body";
    var b = document.createElement("b"); b.textContent = text || "Log in to track your orders";
    var s = document.createElement("span"); s.textContent = "Sign in to see your orders and tailored picks.";
    bodyDiv.appendChild(b); bodyDiv.appendChild(s);
    var ico = document.createElement("div"); ico.className = "bbc-login-ico"; ico.textContent = "🔒";
    el.appendChild(ico); el.appendChild(bodyDiv); el.appendChild(a);
    body.appendChild(el); scroll();
  }

  function renderRecos(qs) {
    if (!qs || !qs.length) return;
    var wrap = document.createElement("div"); wrap.className = "bbc-recos";
    qs.forEach(function (q) {
      var b = document.createElement("button"); b.type = "button"; b.textContent = q;
      b.onclick = function () { send(q); };
      wrap.appendChild(b);
    });
    body.appendChild(wrap); scroll();
  }

  // ADD TO CART → fetch the product's variants (public /products/HANDLE.js, no key) and let the user pick a size
  function sizeOptIdx(prod) {
    var opts = prod.options || [];
    for (var i = 0; i < opts.length; i++) { var nm = (opts[i] && opts[i].name) || opts[i]; if (/size|waist/i.test(nm)) return i; }
    return opts.length - 1;
  }
  function startAdd(p, el, btn) {
    btn.disabled = true; btn.textContent = "…";
    fetch("/products/" + encodeURIComponent(p.handle) + ".js")
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (prod) {
        var variants = (prod.variants || []).filter(Boolean);
        var avail = variants.filter(function (v) { return v.available; });
        if (!avail.length) { btn.textContent = "SOLD OUT"; btn.disabled = true; return; }
        if (variants.length === 1) { doAdd(avail[0].id, el, btn, p); return; }
        // multiple sizes → show size buttons (sold-out sizes shown disabled)
        var idx = sizeOptIdx(prod), wrap = el.querySelector(".bbc-sizes"), seen = {}, html = '<span class="bbc-sizelbl">Select your size:</span>';
        variants.forEach(function (v) {
          var sz = v["option" + (idx + 1)] || v.title; if (seen[sz]) return; seen[sz] = 1;
          html += '<button class="bbc-size' + (v.available ? "" : " oos") + '" data-vid="' + v.id + '"' + (v.available ? "" : " disabled") + ' aria-label="Size ' + esc(sz) + '">' + esc(sz) + "</button>";
        });
        wrap.innerHTML = html; wrap.hidden = false; btn.style.display = "none";
        wrap.querySelectorAll(".bbc-size:not(.oos)").forEach(function (sb) { sb.onclick = function () { doAdd(Number(sb.getAttribute("data-vid")), el, btn, p, sb); }; });
        scroll();
      })
      .catch(function () { if (p.variantId) doAdd(Number(p.variantId), el, btn, p); else { btn.disabled = false; btn.textContent = "TRY AGAIN"; } });
  }
  function doAdd(vid, el, btn, p, sizeBtn) {
    if (sizeBtn) sizeBtn.textContent = "…";
    fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function () {
        var wrap = el.querySelector(".bbc-sizes"); if (wrap) { wrap.hidden = true; wrap.innerHTML = ""; }
        btn.style.display = ""; btn.disabled = true; btn.textContent = "✓ ADDED";
        var added = el.querySelector(".bbc-added"); if (added) added.hidden = false;
        toast("Added to cart"); refreshCart(); markCart(); document.dispatchEvent(new CustomEvent("bbchat:add", { detail: p })); scroll();
      })
      .catch(function () { if (sizeBtn) sizeBtn.textContent = "retry"; else { btn.style.display = ""; btn.disabled = false; btn.textContent = "TRY AGAIN"; } });
  }
  function refreshCart() {
    fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) {
      var n = String(c.item_count);
      try { document.querySelectorAll("[data-cart-count], .cart-count, #CartCount, .js-cart-count, .cart-link__count, .cart-count-bubble span[aria-hidden='true']").forEach(function (e) { e.textContent = n; }); } catch (x) {}
      document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: { cart: c } }));
    }).catch(function () {});
  }

  var HKEY = "bbc_hist_v1";
  function loadHist() { try { return JSON.parse(localStorage.getItem(HKEY)) || []; } catch (e) { return []; } }
  function saveHist() { try { localStorage.setItem(HKEY, JSON.stringify(history.slice(-10))); } catch (e) {} }
  var history = loadHist(); // conversation memory (persisted to localStorage, last 10) — also sent to the backend for context

  // stable session id (groups the whole conversation in the backend log) + happy/sad feedback state
  var SKEY = "bb_sid_v1";
  // rich render-log (localStorage) so product cards / order lists / login card / suggestion chips
  // are RESTORED on reload or when the customer returns — not just the plain text bubbles.
  var RLKEY = "bbc_rlog_v1";
  function loadRlog() { try { return JSON.parse(localStorage.getItem(RLKEY)) || []; } catch (e) { return []; } }
  var rlog = loadRlog();
  function pushRlog(e) { rlog.push(e); if (rlog.length > 16) rlog = rlog.slice(-16); try { localStorage.setItem(RLKEY, JSON.stringify(rlog)); } catch (x) {} }
  function clearRlog() { rlog = []; try { localStorage.setItem(RLKEY, "[]"); } catch (x) {} }
  function replayRlog() {
    history = [];
    rlog.forEach(function (e) {
      if (e.u) { userSay(e.t); history.push({ role: "user", text: e.t }); return; }
      botSay(e.t); history.push({ role: "assistant", text: e.t });
      if (e.o) renderOrders(e.o, e.m || {});
      else if (e.p) renderProducts(e.p, e.d);
      if (e.l) renderLoginCard(e.l[0], e.l[1]);
      if (e.q) renderRecos(e.q);
    });
    history = history.slice(-16); saveHist();
  }
  function loadSid() { try { var s = localStorage.getItem(SKEY) || localStorage.getItem("bbc_sid_v1"); if (s) { localStorage.setItem(SKEY, s); return s; } } catch (e) {} var n = "web-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 8); try { localStorage.setItem(SKEY, n); } catch (e) {} return n; }
  var SID = loadSid();
  // ── CHAT → SALE ATTRIBUTION: mark the cart so a guest order can be traced to this chat (shared w/ PDP drawer via SID + bb_stamped_v1) ──
  var cartToken = "", STAMP_KEY = "bb_stamped_v1";
  // 17 Oct 2026 (patch 77 part 1, his yes): our browser id + visit id go with each chat call, so a guest who proves
  // their phone in the chat is tied to this browser. bl-path.js owns both ids; this only reads them, never makes them.
  function blIds() {
    var b = "", v = "", re = /^[a-z0-9]{20}$/;
    try { b = localStorage.getItem("bl_bid") || ""; } catch (e) {}
    try { v = sessionStorage.getItem("bl_vid") || ""; } catch (e) {}
    return { b: re.test(b) ? b : "", v: re.test(v) ? v : "" };
  }
  function markCart() {
    fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) {
      if (c && c.token) cartToken = String(c.token);
      var already = false;
      try { already = localStorage.getItem(STAMP_KEY) === SID; } catch (e) {}
      if (already || (c && c.attributes && c.attributes.bb_chat === SID)) return;
      return fetch("/cart/update.js", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: { bb_chat: SID } })
      }).then(function () { try { localStorage.setItem(STAMP_KEY, SID); } catch (e) {} });
    }).catch(function () {});
  }
  var RKEY = "bb_reset_v1";
  function getReset() { try { return +(localStorage.getItem(RKEY) || 0) || 0; } catch (e) { return 0; } }
  function setReset(t) { try { localStorage.setItem(RKEY, String(t)); } catch (e) {} }
  (function () { // fresh chat right after login (old chats stay saved on the backend)
    var LKEY = "bb_li_v1", isLI = !!(window.__BB_CUSTOMER && (window.__BB_CUSTOMER.id || window.__BB_CUSTOMER.email)), wasLI = false;
    try { wasLI = localStorage.getItem(LKEY) === "1"; } catch (e) {}
    if (isLI && !wasLI) { setReset(Date.now()); history = []; try { localStorage.setItem(HKEY, "[]"); localStorage.setItem(RLKEY, "[]"); } catch (e) {} }
    try { localStorage.setItem(LKEY, isLI ? "1" : "0"); } catch (e) {}
  })();
  function loadHistory(cb) {
    fetch(ENDPOINT + "/history?session_id=" + encodeURIComponent(SID) + "&since=" + getReset())
      .then(function (r) { return r.json(); }).then(function (j) { cb((j && j.messages) || []); }).catch(function () { cb([]); });
  }
  var botTurns = 0, fbMidShown = false, fbCloseShown = false;
  function fbRecently() { try { var t = +localStorage.getItem("bbc_fb_ts"); return !!t && (Date.now() - t) < 7 * 864e5; } catch (e) { return false; } }
  var fbGiven = fbRecently(); // don't re-ask someone who already rated in the last 7 days
  function sendFeedback(rating, reason, node) {
    if (node) node.innerHTML = '<div class="bbc-fbthanks">Thanks for your feedback! 🙏</div>';
    fbGiven = true; try { localStorage.setItem("bbc_fb_ts", String(Date.now())); } catch (e) {}
    try { fetch(ENDPOINT, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ feedback: { rating: rating, comment: reason || "" }, session_id: SID, customer: window.__BB_CUSTOMER || null }) }); } catch (e) {}
  }
  function renderFeedbackPrompt(promptText, reason) {
    if (fbGiven) return;
    var w = document.createElement("div"); w.className = "bbc-fb";
    w.innerHTML = '<span class="bbc-fbq">' + esc(promptText) + '</span>' +
      '<button class="bbc-fbbtn" data-r="happy" aria-label="Happy">😊</button>' +
      '<button class="bbc-fbbtn" data-r="sad" aria-label="Not happy">😞</button>';
    var btns = w.querySelectorAll(".bbc-fbbtn");
    for (var i = 0; i < btns.length; i++) { (function (b) { b.onclick = function () { sendFeedback(b.getAttribute("data-r"), reason, w); }; })(btns[i]); }
    body.appendChild(w); scroll();
  }
  // per-answer feedback ("Are you OK with this answer?") -> worker (answer_feedback) for admin review.
  // Appended AFTER the product cards, BEFORE the recommendation chips; prominent OK / Not OK buttons.
  function attachThumbs(ctx) {
    try {
      var row = document.createElement("div"); row.className = "bbc-fb";
      row.innerHTML = '<div class="bbc-fb-q">Are you OK with this answer?</div><div class="bbc-fb-btns"><button class="bbc-fbb" type="button" data-r="up" aria-label="OK" title="OK">👍</button><button class="bbc-fbb" type="button" data-r="down" aria-label="Not OK" title="Not OK">👎</button></div>';
      var bs = row.querySelectorAll(".bbc-fbb"), done = false;
      for (var i = 0; i < bs.length; i++) { (function (b) { b.onclick = function () {
        if (done) return; done = true; var r = b.getAttribute("data-r");
        try { fetch(ENDPOINT, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ feedback: { rating: r, answer: ctx.answer, question: ctx.question, qtype: ctx.qtype }, session_id: SID, customer: window.__BB_CUSTOMER || null }) }); } catch (e) {}
        for (var k = 0; k < bs.length; k++) { bs[k].disabled = true; if (bs[k] !== b) bs[k].classList.add("bbc-fb-dim"); }
        b.classList.add("bbc-fb-on");
        var qEl = row.querySelector(".bbc-fb-q"); if (qEl) qEl.textContent = "Thanks for your feedback!";
        scroll();
      }; })(bs[i]); }
      body.appendChild(row); scroll();
    } catch (e) {}
  }
  // Came here from a store page (Changes to make #40, 14 Oct 2026): store pages write localStorage bl_store
  // {c: store code, t: ms} on a product tap; for 3 hours the chat sends store_code and the worker answers
  // in "Ask this store" mode. undefined → JSON leaves the field out.
  function fromStore() {
    try { var s = JSON.parse(localStorage.getItem("bl_store") || "null");
      if (s && /^[A-Z0-9]{2,4}$/.test(String(s.c)) && Date.now() - Number(s.t) < 3 * 3600 * 1000) return String(s.c); } catch (e) {}
    return undefined;
  }
  function send(text) {
    text = (text || input.value || "").trim(); if (!text) return;
    if (!cartToken) markCart();
    input.value = ""; userSay(text); typing(true);
    var prior = history.slice(-6); // context BEFORE this message
    history.push({ role: "user", text: text }); saveHist(); pushRlog({ u: 1, t: text });
    fetch(ENDPOINT, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ message: text, history: prior, session_id: SID, customer: window.__BB_CUSTOMER || null, cart_token: cartToken, store_code: fromStore(), b: blIds().b, v: blIds().v }) })
      .then(function (r) { return r.json(); })
      .then(function (j) { typing(false); var msg = j.ai_message || "Here's what I found."; botSay(msg); history.push({ role: "assistant", text: msg }); if (history.length > 16) history = history.slice(-16); saveHist(); if (j.orders) renderOrders(j.orders, j); else renderProducts(j.products, j.display_layout); if (j.loginCard) renderLoginCard(j.loginUrl, j.loginCardText); attachThumbs({ question: text, answer: msg, qtype: j.query_type }); if (j.recommendedQuestions) renderRecos(j.recommendedQuestions); pushRlog({ t: msg, o: j.orders || null, m: (j.moreUrl ? { moreUrl: j.moreUrl, moreLabel: j.moreLabel } : null), p: (j.orders ? null : (j.products || null)), l: (j.loginCard ? [j.loginUrl, j.loginCardText] : null), q: j.recommendedQuestions || null, d: j.display_layout || null }); botTurns++; })
      .catch(function () { typing(false); botSay("Sorry — I had trouble just now. Mind trying again?"); });
  }
  panel.querySelector("#bbc-send").onclick = function () { send(); };
  input.addEventListener("keydown", function (e) { if (e.key === "Enter") send(); });

  window.BBChat = { open: open, close: close };
})();
